// extracted by mini-css-extract-plugin
export default {"container":"sort_product_select_container__ouFLb","option_container":"sort_product_select_option_container__07X+l"};